import React, { useState, useEffect } from "react"
import { BASE_PATH, SUB_DIRECTORY } from "constants/general"
import { useHistory } from "react-router-dom"
import ModalLoading from "components/Loading"
import MainLayout from "newComponents/Layout/MainLayout"

const PreBeneficios = () => {
    const history = useHistory()
    const solicitaCredito = `${BASE_PATH}${SUB_DIRECTORY}`
    const [ loading, setLoading ] = useState(true)
    
    useEffect(()=>{
        setTimeout(()=>{
            setLoading(false)
            history.push(solicitaCredito)
        },300)
    },[])

    return (
        <MainLayout>
            { loading && <ModalLoading />}
        </MainLayout>
    )
}  

export default PreBeneficios